
import { mapState } from 'vuex';
import PendingReviews from './PendingReviews.vue';

export default {
  i18nComponentKey: 'ReviewsNew.components.ReviewCompleteView',
  name: 'ReviewCompleteView',
  components: {
    PendingReviews
  },
  props: {
    reward: { type: Number, required: true },
    myReviewsUrl: { type: String, required: true }
  },
  data() {
    return { isLoading: true, subOrders: [] };
  },
  computed: {
    ...mapState(['api'])
  },
  created() {
    this.api
      .fetchPendingReviews()
      .then(({ data }) => (this.subOrders = data.sub_orders))
      .finally(() => (this.isLoading = false));
  }
};
